'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodeForge = require('node-forge');

var _curve = require('../keys/curve25519');

var _rsa = require('../keys/rsa');

var _constants = require('./constants');

var _encoding = require('../utils/encoding');

var _utils = require('../utils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SigningPublicKey = function SigningPublicKey(_ref) {
  var publicKey = _ref.publicKey,
      pemPublicKey = _ref.pemPublicKey,
      algo = _ref.algo;

  _classCallCheck(this, SigningPublicKey);

  _initialiseProps.call(this);

  if (publicKey) {
    if (!algo) throw new Error('You must specify the algo when creating from the raw key.');
    this._key = publicKey;
    this._algo = algo;
  } else {
    this.load(pemPublicKey);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.load = function (pemPublicKey) {
    var _decodePublicKey = (0, _encoding.decodePublicKey)(pemPublicKey),
        oid = _decodePublicKey.oid,
        asn1Data = _objectWithoutProperties(_decodePublicKey, ['oid']);

    switch (oid) {
      case _constants.SIGNING_ALGO_RSA.oid:
        _this._key = new _rsa.RSAPublicKey(_nodeForge.pki.publicKeyFromAsn1(asn1Data.rsaPublicKey));
        _this._algo = _constants.SIGNING_ALGO_RSA.name;
        break;
      case _constants.SIGNING_ALGO_ED25519.oid:
        _this._key = new _curve.ED25519PublicKey((0, _utils.stringToBytes)(asn1Data.curve25519PublicKey));
        _this._algo = _constants.SIGNING_ALGO_ED25519.name;
        break;

      default:
        throw new Error('Unsupported signing algorithm OID ' + oid + '"');
    }
  };

  this.verify = function (_ref2) {
    var message = _ref2.message,
        signature = _ref2.signature;

    if (!(message instanceof Uint8Array) || !(signature instanceof Uint8Array)) {
      throw new Error('bad encoding, message and signature should be Uint8Array');
    }

    var sig = (0, _encoding.decodeSignature)((0, _utils.bytesToString)(signature));

    switch (_this._algo) {
      case _constants.SIGNING_ALGO_RSA.name:
      case _constants.SIGNING_ALGO_ED25519.name:
        return _this._key.verify(message, sig);

      default:
        throw new Error('Unsupported signing algorithm "' + _this._algo + '"');
    }
  };

  this.export = function () {
    var asn1PublicKey = void 0;
    switch (_this._algo) {
      case _constants.SIGNING_ALGO_RSA.name:
      case _constants.SIGNING_ALGO_ED25519.name:
        asn1PublicKey = _this._key.toAsn1();
        break;

      default:
        throw new Error('Unsupported encryption algorithm ' + _this._algo + '"');
    }

    return (0, _encoding.encodePublicKey)(asn1PublicKey, _this._algo);
  };
};

exports.default = SigningPublicKey;